import styled from 'styled-components';

const StyledRow = styled.div`
  margin-bottom: 0.5rem;
`;

const StyledLabel = styled.label`
  display: flex;
  align-items: center;
  gap: 0.3rem;
  margin-bottom: 0.25rem;
  font-weight: 500;
`;

const StyledTypeBadge = styled.span`
  color: ${({ theme }) => theme.colors.textMuted};
  font-size: 10.5px;
  font-weight: 400;
`;

const StyledBooleanLabel = styled.label`
  display: flex;
  align-items: center;
  gap: 0.5rem;
`;

const StyledFullWidthInput = styled.input`
  width: 100%;
`;

const StyledSelect = styled.select`
  width: 100%;
`;

export default {
  StyledRow,
  StyledLabel,
  StyledTypeBadge,
  StyledBooleanLabel,
  StyledFullWidthInput,
  StyledSelect,
};
